var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.811,
    height: 25.002,
    viewBox: "0 0 24.811 25.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1652",
    "data-name": "Rectangle 1652",
    width: 24.81,
    height: 25.002,
    fill: "#6a707e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14149",
    "data-name": "Path 14149",
    d: "M0,38.646c.066-.3.12-.595.2-.886a5.138,5.138,0,0,1,4.9-3.745c3.123-.013,6.246,0,9.369,0a4.689,4.689,0,0,1,1.78.359c-.012.209-.111.258-.3.25a2.679,2.679,0,0,0-2.588,1.431q-.392.669-.776,1.343a2.715,2.715,0,0,0,.069,3,.253.253,0,0,1,.028.215,2.756,2.756,0,0,0-.067,3.116c0,.006,0,.016,0,.059H12.33c-3.76,0-7.519-.006-11.278.007A1,1,0,0,1,0,43.179V38.646",
    transform: "translate(0 -20.97)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14150",
    "data-name": "Path 14150",
    d: "M16.77,10.862A5.431,5.431,0,1,1,22.2,5.442a5.434,5.434,0,0,1-5.433,5.42",
    transform: "translate(-6.987 0)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14151",
    "data-name": "Path 14151",
    d: "M47.882,40.649a2.137,2.137,0,0,1-.29.394c-.242.212-.506.4-.768.586a.3.3,0,0,0-.147.338,2.045,2.045,0,0,1,0,.606.3.3,0,0,0,.148.337c.255.182.5.373.752.567a.55.55,0,0,1,.166.8q-.4.709-.813,1.41a.546.546,0,0,1-.775.258c-.3-.12-.59-.259-.894-.366a.46.46,0,0,0-.316.033c-.182.087-.34.231-.526.307a.389.389,0,0,0-.259.386c-.025.3-.065.59-.106.884a.54.54,0,0,1-.565.512q-.853.017-1.706,0a.549.549,0,0,1-.575-.53c-.011-.084-.021-.168-.033-.252a2.222,2.222,0,0,0-.151-.863c-.148-.223-.478-.329-.738-.471a.339.339,0,0,0-.251-.018c-.309.116-.611.253-.917.376a.555.555,0,0,1-.792-.27q-.4-.68-.789-1.366a.57.57,0,0,1,.183-.858c.236-.18.469-.365.713-.534a.3.3,0,0,0,.152-.359,1.039,1.039,0,0,1-.012-.479.435.435,0,0,0-.243-.536c-.226-.15-.438-.321-.651-.489a.546.546,0,0,1-.165-.783q.412-.731.841-1.453a.532.532,0,0,1,.719-.244q.461.181.913.385a.281.281,0,0,0,.347-.034.835.835,0,0,1,.276-.179.737.737,0,0,0,.533-.8,4.105,4.105,0,0,1,.065-.581.54.54,0,0,1,.552-.524c.585-.013,1.172-.013,1.757,0a.531.531,0,0,1,.537.511c.041.3.08.606.109.909.016.164.058.289.236.347a.793.793,0,0,1,.308.173.633.633,0,0,0,.842.072,5.466,5.466,0,0,1,.63-.271.536.536,0,0,1,.737.25q.428.722.84,1.453a2.4,2.4,0,0,1,.125.365m-3.075,1.62a2.175,2.175,0,1,0-2.168,2.176,2.186,2.186,0,0,0,2.168-2.176",
    transform: "translate(-23.072 -22.71)",
    fill: "#6a707e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagement);
export default __webpack_public_path__ + "static/media/ProjectManagement.1357c40300ac94bf8b9a79aa36284ad8.svg";
export { ForwardRef as ReactComponent };